"use client";

import { c as _c } from "react/compiler-runtime";
import { Carousel, CarouselSlide } from "@mantine/carousel";
import ProductCard from "../ProductCard";
export default function AddonsSlider(t0) {
  const $ = _c(8);
  const {
    addons,
    labelMap
  } = t0;
  if (!addons) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-xl text-slate-800 font-heading">Frequently Bought Together</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      loop: true,
      align: "start",
      slidesToScroll: 2
    };
    t3 = {
      base: "50%",
      sm: "33%",
      md: "50%",
      lg: "33.33%",
      xl: "33.33%"
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== addons || $[4] !== labelMap) {
    t4 = addons?.map((product, index) => <CarouselSlide key={index} py="xs"><ProductCard product={product} labelMap={labelMap} /></CarouselSlide>);
    $[3] = addons;
    $[4] = labelMap;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="mt-2">{t1}<Carousel withIndicators={false} withControls={false} emblaOptions={t2} slideSize={t3} slideGap="xs">{t4}</Carousel></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}